(function () {
	const initCollapsibleContent = () => {
		$(".collapsible-content-1__toggle").unbind("click").on("click", function () {
			const parent = $(this).parent();

			if (!parent.hasClass("active")) {
				parent
					.siblings(".collapsible-content-1__item.active")
					.removeClass("active");
				parent.addClass("active");
				$(this)
					.closest(".collapsible-content-1__items")
					.find(".collapsible-content-1__answer")
					.stop()
					.slideUp(300);
				$(this).next().stop().slideDown(300);
			} else {
				parent.removeClass("active");
				$(this).next().stop().slideUp(300);
			}
		});

		$(".collapsible-content-1__item").mouseenter(function (event) {
			$(this).removeClass("collapsible-content-1__item--opacity");
			$(this)
				.siblings()
				.addClass("collapsible-content-1__item--opacity");
			$(this).mouseleave(() => {
				$(this)
					.siblings()
					.removeClass("collapsible-content-1__item--opacity");
			});
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initCollapsibleContent();
	});

	initCollapsibleContent();
})();
